import React, { useState } from 'react'
import { Table } from '../../components/Table/Table'
import { delete_icon, edit_icon, eye_icon, password_icon, toggle_off, toggle_on, view_icon } from '../../assets/imgs';
import { useNavigate } from 'react-router-dom';
import { admin_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import FavoriteIcon from '@mui/icons-material/Favorite';

const DeviceList = () => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [type, setType] = useState('');



  
    const handleChange = () => {
        setToggle(!toggle);
    }

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Device Name",
                accessor: "client",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Device ID",
                accessor: "deviceId",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Assigned",
                accessor: "assigned",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Device Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return <div>
                        <button className={`border-0 toggle-btn cust-btn `}   >
                            {value == "on" ? (
                                <div>
                                    <FavoriteIcon className='green' />
                                </div>
                            ) : (
                                <div>
                                    <FavoriteIcon className='red' />
                                </div>
                            )}
                        </button>
                    </div>;
                },
            },
            {
                Header: " Status",
                accessor: "toggle",
                Cell: ({ value, row }) => {
                    return <div>
                        <button
                            onClick={() => handleChange()}
                            className={`border-0 ms-2 cust-btn `}
                        >
                            {value == "on" ? (
                                <img className="toggle-btn" src={toggle_on} />
                            ) : (
                                <img className="toggle-btn" src={toggle_off} />
                            )}
                        </button>
                    </div>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                <button type='edit'
                                    onClick={() => { setPopup(true); setType("edit") }}
                                    className="cust-btn "
                                >
                                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                </button>

                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Device List
                </h2>
                <button onClick={() => { setPopup(true); setType("add") }} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add Device </button>
            </div>
            {popup && (
                <div className="popup-design">
                    <div className="popup">
                        <div className='d-flex ac-jb'>
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                                Device List
                            </h2>
                            <button onClick={() => { setPopup(false); setType("") }} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn'><CancelIcon /></button>
                        </div>
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Device Name
                        </h4>
                        <input type="text" className="input-pop ps-2 w-100" placeholder=" Name" />
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Device ID
                        </h4>
                        <input type="number" className="input-pop ps-2 w-100" placeholder="Device ID" />
                        {type == "edit" && (
                            <div>
                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                    Assigned To
                                </h4>
                                <select name="" id="" className='input-pop ps-2 w-100'>
                                    <option value="">Sathish</option>
                                    <option value="">Mukesh</option>
                                    <option value="">Aravindh</option>
                                </select>
                            </div>
                        )}
                        <div className="d-flex ac-jc mt-3">
                            <button onClick={() => { setPopup(false); setType("") }} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Table columns={columns} data={admin_list} show={false} />
        </div>
    )
}

export default DeviceList